import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faq";
import { testimonials } from "@/mocks/site";
import FaqAccordion from "@/components/feature/FaqAccordion";

export default function FaqSection() {
  return (
    <section className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1fr] lg:gap-16">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] text-accent-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于信息来源、更新方式与纠错流程，这里先答一遍。
            </p>
            <FaqAccordion items={faqs} />
          </div>

          <div>
            <span className="text-xs font-semibold tracking-[0.2em] text-accent-600">VOICES</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              用户怎么说
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              来自网友、创作者与社群运营者的真实使用反馈。
            </p>
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-6 w-6 items-center justify-center text-accent-400">
                    <i className="ri-double-quotes-l text-lg"></i>
                  </span>
                  <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                    {item.text}
                  </blockquote>
                  <figcaption className="mt-4 border-t border-background-200 pt-3">
                    <div className="font-heading text-sm font-bold text-foreground-950">
                      {item.name}
                    </div>
                    <div className="text-xs text-foreground-500">{item.role}</div>
                  </figcaption>
                </figure>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600"
            >
              了解网报吃瓜的定位与原则
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}